import { forwardRef } from 'react';
import type { PropsWithoutRef } from 'react';

import type { RefElement } from '../../types';
import VisuallyHiddenText from '../VisuallyHiddenText';
import NoValue from '../NoValue/NoValue';

import type { CreditCardDisplayProps } from './CreditCard.types';
import { formatCreditCard } from './utils';

export default forwardRef<
  RefElement<CreditCardDisplayProps>,
  PropsWithoutRef<CreditCardDisplayProps>
>(function CreditCardDisplay({ value, formattingOptions = {}, ...restProps }, ref) {
  const formatted = value ? formatCreditCard(value, formattingOptions) : undefined;

  return (
    <span ref={ref} {...restProps}>
      {formatted ? (
        <>
          <span aria-hidden>{formatted}</span>
          <VisuallyHiddenText>
            {formatted
              .replace(/\s+/g, '.')
              .replace(/([0-9•]\.?)/g, digit => `${digit} `)
              .trim()}
          </VisuallyHiddenText>
        </>
      ) : (
        <NoValue />
      )}
    </span>
  );
});
